import Reveal from '@/components/base/Reveal';

function LoopBackBand() {
  return (
    <section className="w-full border-y border-dashed border-primary-300 bg-primary-50/60 px-4 md:px-8 lg:px-12 py-6 md:py-7">
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:gap-8">
            <div className="flex shrink-0 items-center gap-3">
              <span className="relative flex h-10 w-10 items-center justify-center rounded-full border border-primary-300 bg-background-50">
                <i className="ri-loop-left-line text-[19px] text-primary-600"></i>
                <span className="absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-primary-500 breathe"></span>
              </span>
              <div className="leading-tight">
                <p className="text-[10px] font-data tracking-[0.22em] text-primary-700">
                  LOOP BACK
                </p>
                <p className="mt-0.5 font-heading font-bold text-[14px] text-foreground-950">
                  Reject Path
                </p>
              </div>
            </div>

            <span className="hidden h-10 w-px shrink-0 bg-primary-200 lg:block" />

            <div className="flex min-w-0 flex-1 items-center gap-3">
              <span className="inline-flex shrink-0 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-1.5">
                <span className="h-1.5 w-1.5 rounded-full bg-foreground-400" />
                <span className="whitespace-nowrap font-data text-[11px] tracking-wider text-foreground-700">
                  REJECT
                </span>
              </span>

              <span className="relative h-4 min-w-[44px] flex-1">
                <span className="absolute inset-x-0 top-1/2 block -translate-y-1/2 border-t border-dashed border-primary-300" />
                <span className="flow-x absolute top-1/2 h-1.5 w-1.5 rounded-full bg-primary-500" />
                <i className="ri-arrow-right-s-line absolute right-0 top-1/2 -translate-y-1/2 text-[17px] text-primary-500" />
              </span>

              <span className="inline-flex shrink-0 items-center gap-2 rounded-md border border-primary-300 bg-primary-100 px-3 py-1.5">
                <span className="h-1.5 w-1.5 rounded-full bg-primary-500 breathe" />
                <span className="whitespace-nowrap font-data text-[11px] tracking-wider text-primary-800">
                  01 · INGEST
                </span>
              </span>
            </div>

            <span className="hidden h-10 w-px shrink-0 bg-primary-200 lg:block" />

            <p className="text-[13px] leading-relaxed text-foreground-600 lg:max-w-[340px]">
              A rejected setup never reaches MT5 — the engine rewinds to ingestion and keeps reading
              XAUUSD.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default LoopBackBand;